var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-block',{staticClass:"max960"},[_c('f7-block',{staticClass:"tac",attrs:{"inset":""}},[_vm._v(_vm._s(_vm.$t('NewDoor.saving')))]),_c('div',{staticClass:"tac"},[_c('div',{staticClass:"pwloader _l"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }